import {Component, OnInit} from '@angular/core';
import {FieldWrapper} from '@ngx-formly/core';
import {Observable} from 'rxjs';
import {TransactionTextsService} from '../../services/transaction-texts.service';
import {TransactionTypeTexts} from '@app/checkout/order-confirmation/order-confirmation-list-item/order-confirmation-order-item.model';
import {AsyncPipe} from '@angular/common';

@Component({
  selector: 'dcp-duration-label',
  templateUrl: './duration-label.component.html',
  styleUrls: ['./duration-label.component.scss'],
  imports: [AsyncPipe],
})
export class FormlyDurationLabelComponent extends FieldWrapper implements OnInit {
  public transactionTypeTexts$: Observable<TransactionTypeTexts>;

  constructor(private transactionTextsService: TransactionTextsService) {
    super();
  }

  ngOnInit() {
    this.transactionTypeTexts$ = this.transactionTextsService.getTransactionTypeTexts$();
  }
}
